export const STATUS_DELETE = 0
export const STATUS_ONE = 1
